import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { A3mediaAudiencesService } from 'src/app/services/audiences/a3media-audiences.service';
import { MovistarAudiencesService } from 'src/app/services/audiences/movistar-audiences.service';
import { Audience } from 'src/app/models/services/audiences/movistar/audience';

@Component({
  selector: 'app-movistar-attributes',
  templateUrl: './movistar-attributes.component.html',
  styleUrls: ['./movistar-attributes.component.sass']
})
export class MovistarAttributesComponent implements OnInit {
    @ViewChild('matAutocompleteAudiences') inputAutocompleteAudiences: ElementRef<HTMLInputElement>;
  
    @Input() 
    form: FormGroup;
  
    @Input() 
    updateValueAndValidity: () => void;

    erisAudienceName: string;

    audiences: Audience[] = [];
    filteredAudiences: Audience[] = [];
    newAudience: string = '0';
  
    constructor(
      private movistarAudiencesServices: MovistarAudiencesService,
      private spinnerService: NgxSpinnerService
    ) {
    }
  
    ngOnInit(): void {
      this.spinnerService.show("dialogSpinner");
      this.erisAudienceName = this.form.controls.audienceName.value;
      this.movistarAudiencesServices.getAudiences().subscribe(
        resp => {
          this.audiences = resp;
          this.onNewAudienceSelectedChange();
          
          this.spinnerService.hide("dialogSpinner");
          this.onAudienceChange(null);
        }
      )
    }
     
    resetAudiencesFilter = (): void => {
      this.inputAutocompleteAudiences.nativeElement.value = '';
      this.form.controls.audienceId.setValue(null);
      this.form.controls.audienceName.setValue(null);
      this.filteredAudiences = this.audiences;
      this.updateValueAndValidity();
    }
      
    filterAudiences = (): void => {
      const filterValue = this.inputAutocompleteAudiences.nativeElement.value.toLowerCase();
      this.filteredAudiences = this.audiences.filter(o => this.getAudienceDescription(o).toLowerCase().includes(filterValue));
      if (filterValue != this.getAudienceDescriptionById(+this.form.controls.audienceId.value).toLowerCase())
        this.form.controls.audienceName.setValue(null);
      this.updateValueAndValidity();
    }
  
    onAudienceChange = ($event: MatAutocompleteSelectedEvent): void => {    
      if (this.audiences.length > 0) {
        this.inputAutocompleteAudiences.nativeElement.blur();
        let audienceId: number = +this.form.controls.audienceId.value;
        let audience: Audience = this.audiences.find(x => x.id == audienceId);
        this.form.controls.audienceName.setValue(!!audience ? audience.name : null);
        this.updateValueAndValidity();  
      }
    }
  
    onAudienceDescriptionChange = (): void => {
      this.updateValueAndValidity();
    }

    onNewAudienceSelectedChange = (): void => {
      this.form.controls.audienceId.setValue(null);
      this.form.controls.audienceName.setValue(!!(+this.newAudience) ? this.erisAudienceName : null);
      this.form.controls.audienceName.updateValueAndValidity();
      this.updateValueAndValidity();      
    }

    getAudienceDescription = (audience: Audience): string => {
      return `${audience.id} - ${audience.name}`;
    }

    getAudienceDescriptionById = (audienceId?: number): string => {
      console.log('getAudienceDescriptionById, audienceId: ', audienceId);
      let audience: Audience = this.audiences.find(x => x.id == audienceId);
      return !!audience ? this.getAudienceDescription(audience) : '';
    }    
  }
  